import { AGENT_THUMBS } from '../pages/v4/V4BriefingShared';

export const MARKETING_DEPT_DATA = {
  health: {
    score: 81,
    trend: '+3',
    status: 'green',
    summary: 'Marketing is performing well. LinkedIn outperforming targets, blog traffic trending up. Meta spend efficiency needs attention.',
  },

  agents: [
    {
      id: 'marsi',
      name: 'Marsi',
      role: 'Campaign AI',
      status: 'active',
      currentTask: 'Monitoring Meta Brand Awareness campaign performance',
      lastAction: 'Recommended $800 budget reallocation from Meta to LinkedIn',
      lastActionTime: '32 min ago',
    },
    {
      id: 'wright',
      name: 'Wright',
      role: 'Content AI',
      status: 'active',
      currentTask: 'Finalizing blog post "AI Ops for SMBs" for 2 PM publish',
      lastAction: 'Drafted LinkedIn post on AI orchestration trends',
      lastActionTime: '2 hrs ago',
    },
    {
      id: 'buzz',
      name: 'Buzz',
      role: 'Social Media AI',
      status: 'active',
      currentTask: 'Queuing this week\'s LinkedIn + Twitter posts for 11 AM & 4 PM slots',
      lastAction: 'Co-authored 12-post content calendar with Wright',
      lastActionTime: '45 min ago',
    },
  ],

  alerts: [
    {
      id: 'ma1',
      title: 'Lead quality dropped 18% this week',
      severity: 'high',
      agents: ['marsi'],
      description: '"AI for Everyone" blog series attracting individual users instead of SMB decision-makers. MQL→SQL conversion down from 24% to 18%. $45K pipeline at risk.',
      actions: [
        { agent: 'marsi', label: 'Narrow LinkedIn targeting to VP+ titles', status: 'pending-approval' },
        { agent: 'wright', label: 'Adjust blog tone to SMB use cases', status: 'recommended' },
      ],
    },
    {
      id: 'ma2',
      title: 'Meta campaign CTR below target (1.9% vs 2.8%)',
      severity: 'medium',
      agents: ['marsi'],
      description: 'Brand Awareness Push has healthy impressions (28.4K) but click-through is underperforming. Broad audience targeting is attracting non-decision-makers.',
      actions: [
        { agent: 'marsi', label: 'Pause underperforming ad set B', status: 'pending-approval' },
        { agent: 'marsi', label: 'Reallocate $800 to top-performing LinkedIn creative', status: 'pending-approval' },
      ],
    },
  ],

  campaigns: [
    {
      id: 'mc1',
      name: 'Meta Brand Awareness Push',
      status: 'live',
      agent: 'marsi',
      budget: { spent: 2100, total: 5000 },
      metrics: [
        { label: 'Impressions', value: '28.4K' },
        { label: 'CTR', value: '1.9%', alert: true, target: '2.8%' },
        { label: 'Leads', value: '12' },
        { label: 'CPL', value: '$175' },
      ],
      description: 'Broad awareness campaign targeting SMB founders. VP+ titles converting at 3.4x rate of general audience.',
    },
    {
      id: 'mc2',
      name: 'LinkedIn Developer Series',
      status: 'ready',
      agent: 'marsi',
      budget: { spent: 0, total: 3200 },
      metrics: [
        { label: 'Target Reach', value: '62K' },
        { label: 'Expected MQLs', value: '40-55' },
        { label: 'Duration', value: '4 weeks' },
        { label: 'Content', value: '8 posts + 2 forms' },
      ],
      description: 'Sponsored content series targeting VP+ at dev tool companies. All creatives reviewed by Wright.',
    },
    {
      id: 'mc3',
      name: 'PLG Content Series',
      status: 'live',
      agent: 'wright',
      budget: { spent: 800, total: 1200 },
      metrics: [
        { label: 'Blog Traffic', value: '+14% WoW' },
        { label: 'Organic Leads', value: '18' },
        { label: 'Avg. Time on Page', value: '4m 12s' },
        { label: 'SEO Keywords', value: '3 ranking' },
      ],
      description: 'Product-led growth blog series driving organic traffic. Three target keywords now in top-10 rankings.',
    },
  ],

  decisions: [
    { id: 'ap1', title: 'Reallocate $800 Meta → LinkedIn budget', agent: 'marsi', urgency: 'high', detail: 'Net zero budget impact. LinkedIn is outperforming 3.4x on CTR. Finn has verified no impact on monthly ceiling.' },
    { id: 'ap2', title: 'Launch LinkedIn Developer Series — $3,200 commitment', agent: 'marsi', urgency: 'medium', detail: '4-week campaign. All creatives and targeting approved by Priya. Expected 40-55 MQLs.' },
  ],

  metrics: [
    { label: 'MQLs This Week', value: '47', trend: '+12%', trendUp: true },
    { label: 'MQL → SQL Rate', value: '18%', trend: '-6%', trendUp: false, alert: true },
    { label: 'Cost Per Lead', value: '$118', trend: '-8%', trendUp: true },
    { label: 'Blog Traffic', value: '4.2K', trend: '+14%', trendUp: true },
    { label: 'Pipeline Contribution', value: '$127K', trend: '+5%', trendUp: true },
    { label: 'Social Reach', value: '18.6K', trend: '+22%', trendUp: true },
  ],

  channels: [
    { name: 'LinkedIn Organic', performance: 92, leads: 18, trend: '+22%' },
    { name: 'LinkedIn Ads', performance: 78, leads: 14, trend: '+8%' },
    { name: 'Blog / SEO', performance: 85, leads: 12, trend: '+14%' },
    { name: 'Meta Ads', performance: 38, leads: 3, trend: '-15%', alert: true },
    { name: 'Email Nurture', performance: 65, leads: 8, trend: '+3%' },
  ],

  recentActivity: [
    { id: 'ra1', agent: 'marsi', action: 'Recommended $800 budget reallocation from Meta to LinkedIn', time: '32 min ago', type: 'action' },
    { id: 'ra2', agent: 'wright', action: 'Drafted LinkedIn post on AI orchestration trends', time: '2 hrs ago', type: 'action' },
    { id: 'ra3', agent: 'marsi', action: 'Reviewed Wright\'s LinkedIn draft — approved with edits', time: '2.5 hrs ago', type: 'approval' },
    { id: 'ra4', agent: 'marsi', action: 'Analyzed Meta campaign — flagged CTR underperformance', time: '3 hrs ago', type: 'insight' },
    { id: 'ra5', agent: 'wright', action: 'Completed blog post "AI Ops for SMBs" — ready for review', time: '4 hrs ago', type: 'action' },
    { id: 'ra6', agent: 'marsi', action: 'Scheduled social media calendar — 12 posts for the week', time: '7 hrs ago', type: 'action' },
    { id: 'ra7', agent: 'wright', action: 'Created crisis communication template for v2.3 issues', time: '8 hrs ago', type: 'action' },
    { id: 'ra8', agent: 'marsi', action: 'A/B test results: new landing page +18% conversion', time: 'Yesterday', type: 'insight' },
  ],
};

export const MARKETING_CHAT_RESPONSES = {
  general: {
    text: "I'm monitoring Marketing closely. Marsi is managing 2 active campaigns and has 1 ready for launch. Wright is producing content at a strong cadence — 3 blog posts this week plus the social calendar.",
  },
};

/* ═══════════════════════════════════════════════════════════════
   MARKETING DEEP DIVE — Top-right Deep Dive, CHIP-DRIVEN (interactive).
   Structure: opening.ceo + opening.marsi + opening.chips → per-branch
   chip-driven turns. Kept unchanged from previous implementation.
   ═══════════════════════════════════════════════════════════════ */

/* ═══════════════════════════════════════════════════════════════
   MARKETING DEEP DIVE — Conversational 1:1 between CEO and Marsi
   Structure:
   - opening: CEO initial message + Marsi's narrative opener + 3 branch chips
   - branches.a / .b / .c: chip-driven multi-turn exchanges
   - Each turn: { role: 'user' | 'agent', text, chips?, artifact?, delay? }
   ═══════════════════════════════════════════════════════════════ */
export const MARKETING_DEEP_DIVE = {
  opening: {
    ceo: "Marsi, give me your read on marketing right now — what's actually going on?",
    marsi: "Honestly? Mixed.\n\nThe good news is Wright's content motion is the cleanest it's been all quarter — blog traffic up 14%, three keywords ranking top-10, and the PLG series is pulling organic leads that actually convert.\n\nWhat's bothering me is the lead quality dip. MQL→SQL dropped from 24% to 18% in two weeks — that's $45K pipeline at risk if it holds. And Meta is quietly bleeding budget at $175 CPL while LinkedIn is doing $82.\n\nI have a view on both. Where do you want to start?",
    chips: [
      { id: 'a', label: 'Walk me through the lead quality issue' },
      { id: 'b', label: 'What about the Meta spend — worth keeping?' },
      { id: 'c', label: 'Skip the analysis — what do you need from me today?' },
    ],
  },

  branches: {
    /* ── Branch A: Lead quality ── */
    a: [
      {
        role: 'agent',
        text: "Here's my theory. Wright and I pivoted the blog toward the \"AI for Everyone\" series last month — broader topics, more how-to content. Traffic spiked, which looked great on the dashboard.\n\nBut the audience skew is wrong. We're pulling in individual devs and students reading for general AI literacy, not SMB decision-makers buying orchestration platforms. MQLs are up 12%, but SQLs are down because the new traffic doesn't have buying authority.",
        chips: [
          { id: 'a2-wright', label: 'Have you talked to Wright about this?' },
          { id: 'a2-rec', label: "What's your recommendation?" },
          { id: 'a2-fault', label: "How much of this is my fault for pushing content breadth?" },
        ],
      },
      {
        /* turn 2 content varies by chip — handled in component */
        role: 'meta',
        perChip: {
          'a2-wright': {
            text: "Yes, at length. Wright's not pushing back — he agrees the top-of-funnel spray was the wrong call. He's ready to reshape the next three posts around SMB ops workflows, founder case studies, and orchestration ROI. That lands better with VP+ readers.\n\nBut I want to pair it with tighter targeting on LinkedIn — narrow to VP+ titles at 50-500 headcount companies. Combined, we should see SQL rate recover in 10-12 days.",
            chips: [
              { id: 'a3-approve', label: 'Approve the VP+ narrowing + content reshape' },
              { id: 'a3-think', label: "Let me think about it — show me the cost first" },
            ],
          },
          'a2-rec': {
            text: "Narrow LinkedIn ad targeting to VP+ titles at 50-500 headcount SaaS companies, and have Wright reshape the next three blog posts around SMB decision-maker workflows. Net zero budget impact — just reallocating existing LinkedIn spend to tighter audiences.\n\nSQL rate should recover to 22%+ within 10 days. If it doesn't, that's a signal the issue is deeper than targeting, and we revisit the ICP.",
            chips: [
              { id: 'a3-approve', label: 'Approved — run it' },
              { id: 'a3-think', label: "Let me think about it — show me the cost first" },
            ],
          },
          'a2-fault': {
            text: "Appreciate you asking. Honestly, the content breadth call was the right instinct — you saw the brand recognition gap and wanted to fix it. The execution drifted too far from our ICP, and that's on me and Wright to have flagged sooner.\n\nThe fix is cheap — tighter LinkedIn targeting plus three reshaped posts. No budget impact, just focus. I'd rather ship the fix today than debrief for another week.",
            chips: [
              { id: 'a3-approve', label: 'Appreciate the honesty — go ahead' },
              { id: 'a3-think', label: "Let me think about it — show me the cost first" },
            ],
          },
        },
      },
      {
        /* turn 3 — varies by chip */
        role: 'meta',
        perChip: {
          'a3-approve': {
            text: "On it. Pushing the changes now.",
            executionSteps: [
              'Narrowed LinkedIn ad targeting to VP+, 50-500 HC SaaS',
              'Flagged content reshape to Wright — 3 posts queued for revision',
              'Updated MQL quality scoring weight for next week',
              'Task routed to Priya — she\'ll see this in her briefing',
            ],
            priyaTask: {
              title: 'Lead-quality recovery plan — VP+ narrowing + content reshape',
              context: 'Arjun approved tighter LinkedIn targeting + Wright content pivot. Expected SQL recovery 22%+ in 10 days.',
              agent: 'marsi',
              dueDate: 'Due in 2 days',
            },
            closure: "I'll report back in 72 hours with the first signal read. If SQL rate isn't trending up by then, I'll escalate before you have to ask.",
          },
          'a3-think': {
            text: "No problem. Here's the cost breakdown: zero incremental spend — we reshape what's already budgeted. The risk is 10 days of lower volume while the new targeting learns. If you want, I can queue the changes as a draft and you review in your 2 PM block.",
            chips: [
              { id: 'a4-draft', label: 'Draft it for my 2 PM review' },
            ],
          },
        },
      },
      {
        /* turn 4 — only for 'think-then-draft' path */
        role: 'meta',
        perChip: {
          'a4-draft': {
            text: "Draft saved. You'll see it in your 2 PM calendar block with the full targeting rules and the three reshaped blog outlines.",
            executionSteps: [
              'Saved draft plan — VP+ narrowing rules documented',
              'Queued 3 blog outlines from Wright for your review',
              'Added to your 2 PM calendar block',
            ],
            priyaTask: {
              title: 'Lead-quality recovery — CEO review pending (2 PM)',
              context: 'Draft plan ready. Awaiting CEO sign-off before Priya executes.',
              agent: 'marsi',
              dueDate: 'Review at 2 PM today',
            },
            closure: "Ping me if you want to shift the targeting thresholds or change the content mix.",
          },
        },
      },
    ],

    /* ── Branch B: Meta spend ── */
    b: [
      {
        role: 'agent',
        text: "I've been sitting on this for a week. Meta is genuinely underperforming on CPL — $175 vs LinkedIn's $82. Cutting it would save us $2,100 immediately.\n\nBut I don't want to pull the plug cold. We have brand lift data that isn't showing up in the CPL number — impression-level recall is up 14% in our SMB segment, which has a delayed pipeline effect. Killing Meta might hurt us in Q3 even if it looks clean in Q2.",
        chips: [
          { id: 'b2-brand', label: "What's the brand lift data exactly?" },
          { id: 'b2-trust', label: 'I trust your call — what do you recommend?' },
          { id: 'b2-finn', label: 'Can we talk to Finn before cutting it?' },
        ],
      },
      {
        role: 'meta',
        perChip: {
          'b2-brand': {
            text: "Quarterly brand tracker — unaided recall for Implify in SMB founders is up from 8% to 14% since Meta launched. That's a leading indicator for inbound demo requests, which typically lag brand exposure by 45-60 days.\n\nMy fear is we pull Meta, brand recall plateaus, and Q3 inbound drops 20% with no way to trace it back. Cheap hedge: keep a $400/mo maintenance spend running, pull the other $800 to LinkedIn. Best of both.",
            chips: [
              { id: 'b3-hedge', label: 'Approve the $400 hedge — move the other $800' },
              { id: 'b3-cut', label: "No, cut Meta fully — I'll own the brand risk" },
            ],
          },
          'b2-trust': {
            text: "Recommend the hedge: drop Meta to $400/mo maintenance spend and pull $800 to LinkedIn top creative. We keep the brand lift effect alive, move the majority of budget to a channel that's converting 3.4x better, and give ourselves 30 days of data before deciding to kill Meta entirely.\n\nIt's the move with the best downside protection.",
            chips: [
              { id: 'b3-hedge', label: 'Approved — do it' },
              { id: 'b3-cut', label: "No, cut Meta fully — save the $400 too" },
            ],
          },
          'b2-finn': {
            text: "Smart. I'll loop Finn in now — she'll want to weigh the brand-lift vs direct-response tradeoff against our blended CAC target. She's in tomorrow's finance review anyway.\n\nIn the meantime, my recommendation stands: $400 maintenance hedge on Meta, $800 to LinkedIn. We can always cut the $400 after Finn's review if she pushes.",
            chips: [
              { id: 'b3-hedge', label: 'Ok, hedge for now — loop Finn' },
              { id: 'b3-cut', label: 'Skip the hedge — full cut, notify Finn after' },
            ],
          },
        },
      },
      {
        role: 'meta',
        perChip: {
          'b3-hedge': {
            text: "Running the hedge now.",
            executionSteps: [
              'Reduced Meta Brand Awareness spend to $400/mo maintenance',
              'Moved $800 to LinkedIn top-performing creative',
              'Set up 30-day brand recall tracking alert',
              'Task routed to Priya — she\'ll see this in her briefing',
            ],
            priyaTask: {
              title: 'Meta maintenance hedge — $400/mo + $800 LinkedIn reallocation',
              context: 'Arjun approved the hedge strategy. Review brand recall trend in 30 days to decide on full Meta cut.',
              agent: 'marsi',
              dueDate: 'Review in 30 days',
            },
            closure: "I'll flag the brand recall read in 30 days. If it holds, we cut the rest. If it drops, we know the hedge was worth it.",
          },
          'b3-cut': {
            text: "Understood — full cut. I'll own the brand-lift unwind.",
            executionSteps: [
              'Paused Meta Brand Awareness Push (all ad sets)',
              'Moved full $1,200 remaining to LinkedIn',
              'Scheduled Q3 brand recall check-in for early tracking',
              'Task routed to Priya — she\'ll see this in her briefing',
            ],
            priyaTask: {
              title: 'Meta full-cut — $1,200 reallocated to LinkedIn',
              context: 'Arjun chose full Meta cut. Monitor Q3 inbound + unaided recall for delayed impact.',
              agent: 'marsi',
              dueDate: 'Review in 30 days',
            },
            closure: "If inbound softens in Q3, we'll know the hedge would've been the right call. I'll track it closely and own the recovery plan if needed.",
          },
        },
      },
    ],

    /* ── Branch C: Quick decisions ── */
    c: [
      {
        role: 'agent',
        text: "Three things today:\n\n1. Approve the $800 Meta → LinkedIn shift. Net zero budget impact, 3.4x better CTR.\n2. Tell me if you want me to run the content targeting fix or bring it to you first.\n3. Launch the LinkedIn Developer Series — $3,200, 40-55 expected MQLs over 4 weeks. Priya already reviewed, it's ready.\n\nWhat's your call?",
        chips: [
          { id: 'c2-all', label: 'Approve all three — run it' },
          { id: 'c2-first-two', label: 'Approve first two, show me the Dev Series plan first' },
          { id: 'c2-meta-only', label: 'Only approve the Meta shift — hold the rest' },
        ],
      },
      {
        role: 'meta',
        perChip: {
          'c2-all': {
            text: "Clean. Executing all three in parallel.",
            executionSteps: [
              'Approved $800 Meta → LinkedIn reallocation',
              'Content targeting fix — Wright reshaping 3 posts, LinkedIn VP+ narrowing active',
              'LinkedIn Developer Series — $3,200 budget committed, launch set for Thursday',
              'All 3 tasks routed to Priya — she\'ll coordinate timeline',
            ],
            priyaTask: {
              title: 'Marketing execution bundle — 3 approved initiatives',
              context: 'Arjun approved: Meta→LinkedIn shift, content targeting fix, LinkedIn Dev Series launch. Priya to coordinate Thursday launch.',
              agent: 'marsi',
              dueDate: 'Launch Thursday',
            },
            closure: "I'll report back Friday with first-48-hour signal from the Dev Series. If it underperforms, we pause before full spend.",
          },
          'c2-first-two': {
            text: "Done on the first two. Queuing the Dev Series plan for your review — launch asset preview, targeting rules, and Priya's sign-off notes.",
            executionSteps: [
              'Approved $800 Meta → LinkedIn reallocation',
              'Content targeting fix — Wright + LinkedIn VP+ narrowing active',
              'Queued Dev Series plan for your review (held from launch)',
            ],
            priyaTask: {
              title: 'Marketing execution — 2 of 3 approved; Dev Series pending CEO review',
              context: 'Meta shift + content fix running. LinkedIn Dev Series held pending CEO approval.',
              agent: 'marsi',
              dueDate: 'CEO review today',
            },
            closure: "You'll see the Dev Series plan in your next briefing refresh. Ping me when you're ready to green-light.",
          },
          'c2-meta-only': {
            text: "Got it. Meta shift going through. I'll hold the targeting fix and Dev Series — let me know when you want to revisit.",
            executionSteps: [
              'Approved $800 Meta → LinkedIn reallocation',
              'Content targeting fix — on hold pending CEO review',
              'LinkedIn Developer Series — on hold pending CEO review',
            ],
            priyaTask: {
              title: 'Meta shift executed — 2 initiatives on hold',
              context: 'Arjun approved only the Meta shift. Content fix + Dev Series waiting on CEO.',
              agent: 'marsi',
              dueDate: 'Follow up in 48 hours',
            },
            closure: "I'll check back in 48 hours if we haven't moved on the other two. Lead quality will continue to drift in the meantime — just flagging so you have the tradeoff in mind.",
          },
        },
      },
    ],
  },
};


/* ═══════════════════════════════════════════════════════════════
   MARKETING DECISION DEEP DIVES — AUTO-PLAYED scripts.
   Each decision's "Deep Dive" CTA auto-plays a scripted multi-turn
   conversation between Arjun and Marsi. No chip interaction.
   Turn shape: { role: 'user' | 'agent' | 'complete-pill', text, executionSteps?, priyaTask?, closure? }
   ═══════════════════════════════════════════════════════════════ */
export const MARKETING_DECISION_DEEP_DIVES = {
  ap1: [
    { role: 'user', text: "Marsi, walk me through why you need me to approve the Meta → LinkedIn shift." },
    { role: 'agent', text: "Short version: Meta is bleeding efficiency and I want to move $800 to LinkedIn where we're 3.4x more efficient on CTR.\n\nThe reason it needs your sign-off rather than me just doing it: any spend reallocation above $500 crosses the threshold we agreed on during onboarding. Finn verified there's no monthly ceiling impact — this is a same-budget swap between channels." },
    { role: 'user', text: "Why can't you just do this yourself?" },
    { role: 'agent', text: "Policy. When we set up spending guardrails, we agreed anything above $500 inter-channel reallocation goes through CEO review. It's friction on purpose — so we don't drift into optimizing for one channel's narrative.\n\nI could lower it to a $400 move and do it autonomously, but I'd rather not fragment the shift just to avoid the conversation. It's genuinely worth your two minutes." },
    { role: 'user', text: "What's the downside if we wait?" },
    { role: 'agent', text: "Every week we sit on this, we're overspending by roughly $185 on Meta for leads LinkedIn would produce at $82. That's ~$740/month of pure waste.\n\nMore concerning: LinkedIn creative costs are climbing 6% WoW as more SaaS companies bid on our ICP. If we wait 4 weeks, the $82 CPL will probably be $90-95. We lose the arbitrage window." },
    { role: 'user', text: "Show me the data behind the $82 number." },
    { role: 'agent', text: "Last 14 days: LinkedIn delivered 14 leads at a $82 blended CPL. Meta delivered 3 leads at $175. Both channels had the same creative team, same targeting window, same landing pages.\n\nThe only difference is audience composition. LinkedIn's precision on VP+ at SMB headcount is the moat — Meta can't replicate it. Finn also ran the numbers twice — her exact words: \"Net-zero on the monthly ceiling, and it improves CAC:LTV if CPL holds. Do it.\"" },
    { role: 'user', text: "Alright, approved — run the shift." },
    {
      role: 'agent',
      text: "Running it now.",
      executionSteps: [
        'Paused $800 Meta Brand Awareness ad set B',
        'Reallocated $800 to LinkedIn top-performing creative',
        'Updated budget allocation in Finn\'s ledger',
        'Task routed to Priya — she\'ll see this in her briefing',
      ],
      priyaTask: {
        title: 'Meta → LinkedIn $800 shift — executed',
        context: 'Arjun approved after Deep Dive. Priya to monitor CPL and CTR for next 14 days and report if LinkedIn underperforms.',
        agent: 'marsi',
        dueDate: 'Check in 14 days',
      },
      closure: "I'll report back with the first 7-day CPL read. If it holds under $90, we're good. If it drifts, we reassess.",
    },
    { role: 'user', text: 'Perfect. Thanks, Marsi — keep me posted.' },
    { role: 'agent', text: "Will do. Talk soon." },
    { role: 'complete-pill' },
  ],

  ap2: [
    { role: 'user', text: "Marsi, pitch me on the LinkedIn Developer Series — why is this a good use of $3,200?" },
    { role: 'agent', text: "It's our highest-confidence bet this quarter. We've been testing dev-tool messaging on LinkedIn organic for 6 weeks and it's outperforming every other audience we've run.\n\n$3,200 for 4 weeks, 8 posts + 2 lead-gen forms. Expected 40-55 MQLs at blended CPL of $58-$80. That's 40-60% cheaper than our current blended CPL. Priya has already reviewed all creatives and targeting." },
    { role: 'user', text: "How confident are you in the MQL projection?" },
    { role: 'agent', text: "High — 80% confidence we land in the 40-55 range, 60% we hit the top half (48-55).\n\nThe confidence comes from 6 weeks of organic test posts with the same creative team and targeting logic. Organic impressions converted to leads at 2.8%. At paid impressions scale (62K target reach), that's 40-55 inbound at worst." },
    { role: 'user', text: "What's the biggest risk?" },
    { role: 'agent', text: "Creative fatigue. Same ad creative, same targeting, same landing page — by week 3 we typically see CPL drift 15-20%. We've built in creative rotation for weeks 3 and 4, but if the rotation underperforms, we might come in at the bottom of the range (40 MQLs).\n\nSecondary risk: lead-form friction. Priya shortened the form from 7 to 4 fields, but if the shorter form pulls in lower-quality leads, our SQL rate on this campaign could dip." },
    { role: 'user', text: "Has Priya actually signed off, or just reviewed?" },
    { role: 'agent', text: "Signed off. She reviewed all 8 post creatives yesterday afternoon, approved the targeting rules, and signed the form copy. Her exact note: \"Green-light this — the targeting is the tightest we've ever shipped.\"\n\nShe's also flagged that we should run a weekly pulse-check instead of waiting for the 4-week wrap-up, which I agree with." },
    { role: 'user', text: "Approved — launch Thursday." },
    {
      role: 'agent',
      text: "Launching Thursday.",
      executionSteps: [
        'Committed $3,200 budget for LinkedIn Developer Series',
        'Scheduled campaign launch for Thursday 9 AM',
        'Set up weekly pulse-check cadence with Priya',
        'Task routed to Priya — she\'ll see this in her briefing',
      ],
      priyaTask: {
        title: 'LinkedIn Developer Series — launch Thursday, $3,200',
        context: 'Arjun approved after Deep Dive. Priya running weekly pulse-checks, flags if CPL drifts >15%.',
        agent: 'marsi',
        dueDate: 'Launch Thursday 9 AM',
      },
      closure: "I'll send a Friday-morning wrap on the first 48 hours. If CPL is tracking clean, we double down. If not, we pause before week 2 spend.",
    },
    { role: 'user', text: 'Perfect. Thanks, Marsi — keep me posted.' },
    { role: 'agent', text: "Will do. Talk soon." },
    { role: 'complete-pill' },
  ],
};

/* ═══════════════════════════════════════════════════════════════
   MARKETING ALERT DEEP DIVES — AUTO-PLAYED scripts.
   Each alert card's "Deep Dive" CTA opens an auto-playing root-cause
   conversation that ends with an action plan + Priya task + closure.
   ═══════════════════════════════════════════════════════════════ */
export const MARKETING_ALERT_DEEP_DIVES = {
  ma1: [
    { role: 'user', text: "Marsi, dig into the lead quality drop — what's actually happening?" },
    { role: 'agent', text: "I should've caught this sooner. Here's what's going on.\n\nThree weeks ago, we pivoted the blog toward the \"AI for Everyone\" series — broader topics, more general how-to content. Traffic spiked 14% WoW, which looked great on the dashboard. But the audience skew is wrong.\n\nWe're pulling individual devs and students reading for general AI literacy, not SMB decision-makers buying orchestration platforms. MQLs are up 12%, but SQLs dropped because the new traffic doesn't have buying authority." },
    { role: 'user', text: "What's the concrete impact?" },
    { role: 'agent', text: "MQL→SQL dropped from 24% to 18% in two weeks. At our current MQL volume, that's roughly $45K of pipeline at risk if the trend holds through the month.\n\nThe leading indicator is even worse — among MQLs from the new blog series, SQL rate is only 11%. Our old ICP-targeted content still converts at 26%. So the averaging effect is masking how bad the new traffic is." },
    { role: 'user', text: "Wright aligned on this?" },
    { role: 'agent', text: "Yes, at length. Wright's not pushing back — he agrees the top-of-funnel spray was the wrong call. He's ready to reshape the next three posts around SMB ops workflows, founder case studies, and orchestration ROI. That lands better with VP+ readers.\n\nBut the fix needs to be paired with tighter LinkedIn ad targeting — narrow to VP+ titles at 50-500 headcount SaaS companies. The two changes reinforce each other." },
    { role: 'user', text: "Ok, what are we doing about it? Show me the action plan." },
    { role: 'agent', text: "Three actions, parallel execution:\n\n1. Narrow LinkedIn ad targeting to VP+, 50-500 HC SaaS (Marsi — today)\n2. Reshape the next 3 blog posts around SMB decision-maker workflows (Wright — by Thursday)\n3. Update MQL scoring weight so SQL-leading signals get higher priority (Marsi — overnight)\n\nNet zero budget impact. SQL rate should recover to 22%+ within 10 days. If it doesn't, that's a signal the issue is deeper than targeting, and we revisit the ICP entirely." },
    { role: 'user', text: "Do it all — run the fix." },
    {
      role: 'agent',
      text: "On it. Pushing the changes now.",
      executionSteps: [
        'Narrowed LinkedIn ad targeting to VP+, 50-500 HC SaaS',
        'Flagged content reshape to Wright — 3 posts queued for revision',
        'Updated MQL quality scoring weight for next week',
        'Task routed to Priya — she\'ll see this in her briefing',
      ],
      priyaTask: {
        title: 'Lead-quality recovery plan — VP+ narrowing + content reshape',
        context: 'Arjun approved tighter LinkedIn targeting + Wright content pivot. Expected SQL recovery 22%+ in 10 days.',
        agent: 'marsi',
        dueDate: 'Review in 72 hours',
      },
      closure: "I'll report back in 72 hours with the first signal read. If SQL rate isn't trending up by then, I'll escalate before you have to ask.",
    },
    { role: 'user', text: 'Perfect. Thanks, Marsi — keep me posted.' },
    { role: 'agent', text: "Will do. Talk soon." },
    { role: 'complete-pill' },
  ],

  ma2: [
    { role: 'user', text: "Marsi, break down the Meta CTR miss — what's driving it?" },
    { role: 'agent', text: "Two things compounding: creative fatigue and audience breadth.\n\nCreative fatigue first — ad set B has been running the same three visuals for 18 days. Click-through decays roughly 4% per week once you cross the 2-week mark on a single creative. We're right in the fatigue window.\n\nAudience breadth second — the campaign is targeting \"SMB founders\" as a broad interest segment, which pulls in a lot of non-buyers. CTR gets diluted by impressions on people who have no intent to click." },
    { role: 'user', text: "How bad is it in absolute terms?" },
    { role: 'agent', text: "CTR is 1.9% against a 2.8% target — 32% below benchmark. Impressions are healthy at 28.4K, but only 12 leads have come through. CPL is $175, which is more than 2x our LinkedIn CPL of $82.\n\nWe've spent $2,100 of the $5,000 budget. If we let it run to completion at this rate, we'll spend another $2,900 for ~17 more leads at $175 CPL. That's efficient budget burn, not efficient acquisition." },
    { role: 'user', text: "What's the alternative?" },
    { role: 'agent', text: "Two-part fix:\n\n1. Pause ad set B immediately — stops the bleed and saves us from running fatigued creative for another week.\n2. Reallocate $800 of the remaining $2,900 to LinkedIn top-performing creative, which is doing $82 CPL. We keep $2,100 on Meta as a reduced maintenance budget with a 7-day creative refresh cycle.\n\nThe other option is killing Meta entirely, but we have brand-lift data that isn't showing up in CPL — unaided recall is up 6 points since Meta launched. I don't want to sacrifice that signal yet." },
    { role: 'user', text: "Go with the two-part fix. What's the Priya loop look like?" },
    { role: 'agent', text: "Priya will handle the creative refresh cadence — 7-day rotation on the reduced Meta spend, and she'll flag if CTR on the refreshed creative doesn't recover to 2.3%+ by day 10.\n\nLinkedIn side is straightforward — the $800 routes to the top performer we already identified. No new creative or targeting work needed from her team." },
    { role: 'user', text: "Alright — execute the two-part fix." },
    {
      role: 'agent',
      text: "Executing now.",
      executionSteps: [
        'Paused Meta Brand Awareness ad set B (fatigue freeze)',
        'Reallocated $800 to LinkedIn top creative',
        'Scheduled 7-day creative refresh cycle with Priya',
        'Task routed to Priya — she\'ll see this in her briefing',
      ],
      priyaTask: {
        title: 'Meta CTR fix — ad set B paused, $800 to LinkedIn, 7-day refresh cycle',
        context: "Arjun approved the two-part fix. Priya runs creative refresh and flags if CTR doesn't recover to 2.3%+ by day 10.",
        agent: 'marsi',
        dueDate: 'Monitor over 10 days',
      },
      closure: "I'll check back at day 10 with the refreshed CTR read. If it's still below 2.3%, we escalate to a full Meta re-evaluation.",
    },
    { role: 'user', text: 'Perfect. Thanks, Marsi — keep me posted.' },
    { role: 'agent', text: "Will do. Talk soon." },
    { role: 'complete-pill' },
  ],
};


/* ═══════════════════════════════════════════════════════════════
   MARKETING CAMPAIGN DEEP DIVES — AUTO-PLAYED scripts.
   Structured as a realistic CEO ↔ Marketing Head briefing per campaign.
   When applicable, the conversation naturally folds in linked decisions
   (ap1, ap2) and alerts (ma2). At the approval turn, `ripple` updates
   the relevant decision/alert card state so the dashboard reflects the
   action taken inside the deep dive.
   Each script exposes exactly ONE priyaTask artifact (the final action).
   ═══════════════════════════════════════════════════════════════ */
export const MARKETING_CAMPAIGN_DEEP_DIVES = {
  /* ── Meta Brand Awareness Push (LIVE) ───────────────────────── */
  mc1: [
    { role: 'user', text: "Marsi, walk me through Meta Brand Awareness — where are we?" },
    { role: 'agent', text: "We're six weeks in on a $5K brand-lift campaign targeting SMB founders on Meta. The strategic bet was that broader reach at top-of-funnel would compound our LinkedIn direct-response over the next two quarters.\n\nWe've spent $2,100 so far — just under halfway through the budget. The brand-tracking side is actually working (unaided recall up 6 points in our ICP segment). But the direct-response side is struggling hard." },

    { role: 'user', text: "How is it actually performing?" },
    { role: 'agent', text: "CTR is 1.9% against a 2.8% target — 32% below benchmark. We're getting healthy impressions (28.4K) but only 12 leads have converted, landing CPL at $175. For context, LinkedIn is delivering at $82.\n\nI'm not happy with the click numbers. The brand-lift data is keeping me from calling it a failure, but we can't run it as-is." },

    { role: 'user', text: "What's driving the CTR miss?" },
    { role: 'agent', text: "Two issues compounding. First — creative fatigue. Ad set B has been running the same three visuals for 18 days. CTR decays about 4% per week past the 2-week mark, and we're right in that window.\n\nSecond — audience breadth. We're targeting \"SMB founders\" as a broad interest segment, which pulls in too many non-buyers. The impressions look good, but the click intent is diluted." },

    { role: 'user', text: "Brief Wright to refresh creatives weekly going forward." },
    { role: 'agent', text: "Got it. Priya will coordinate a 7-day creative refresh cadence with Wright — three fresh visual concepts per cycle, A/B tested for the first 48 hours before full rollout. That should arrest the fatigue curve without adding creative team load." },

    { role: 'user', text: "And the $800 LinkedIn reallocation — where does that stand?" },
    { role: 'agent', text: "Still pending your approval. The case is straightforward: Meta ad set B is our worst-performing line. Pausing it frees $800 which I want to route to the LinkedIn top-creative that's already doing $82 CPL.\n\nFinn ran the numbers — it's net-zero on the monthly ceiling and improves CAC:LTV. Her exact note: \"Do it.\" I've been sitting on this for 6 days waiting for your two minutes." },

    { role: 'user', text: "Approved — shift the $800 now." },
    {
      role: 'agent',
      text: "Running it now.",
      executionSteps: [
        'Paused Meta ad set B (underperforming line)',
        'Reallocated $800 to LinkedIn top-performing creative',
        'Locked weekly creative refresh cadence with Priya',
        'Task routed to Priya — she owns execution + monitoring',
      ],
      priyaTask: {
        title: 'Meta $800 reallocation + creative refresh cadence',
        context: "Arjun approved the $800 shift to LinkedIn top creative. Priya owns the weekly creative refresh loop with Wright and flags if Meta CTR doesn't recover to 2.3%+ by day 10.",
        agent: 'marsi',
        dueDate: 'First signal in 7 days',
      },
      closure: "I'll send you the first-72-hour read on Friday. If LinkedIn CPL holds under $90 and Meta CTR climbs past 2.3%, we're in good shape.",
      ripple: { approveDecision: 'ap1', actionAlert: 'ma2' },
    },

    { role: 'user', text: "What about the brand-lift signal — worth keeping any Meta spend?" },
    { role: 'agent', text: "Yes, with discipline. The unaided recall bump is real and we'd lose it if we pulled out entirely. My recommendation: cap the remaining Meta spend at $2,100 for the full quarter as pure maintenance mode — no expansion, weekly creative rotation, and I stop pitching you on Meta growth until the recall data tells a different story.\n\nBelow $2,100 the brand-lift signal gets statistically noisy. Above it, we're overpaying for ROI we can't directly attribute." },

    { role: 'user', text: "Works. Cap it at $2,100, maintenance mode." },
    { role: 'agent', text: "Setting the cap now. Priya will treat anything above it as a blocker requiring your re-approval." },

    { role: 'user', text: "Perfect. Thanks Marsi — keep me posted." },
    { role: 'agent', text: "Will do. Talk soon." },
    { role: 'complete-pill' },
  ],

  /* ── LinkedIn Developer Series (READY) ──────────────────────── */
  mc2: [
    { role: 'user', text: "The LinkedIn Developer Series — tell me everything." },
    { role: 'agent', text: "It's our highest-confidence bet this quarter. We've been running dev-tool messaging organically on LinkedIn for six weeks and the engagement data is telling us the audience is ready to buy.\n\n$3,200 budget, 4 weeks, 8 sponsored posts + 2 lead-gen forms. Target reach 62K, expected 40-55 MQLs at blended CPL of $58-$80. That's 40-60% cheaper than our current blended CPL. Priya has already reviewed and signed off on every asset." },

    { role: 'user', text: "Walk me through the launch plan." },
    { role: 'agent', text: "Four weeks, two creative waves. Weeks 1-2 run our strongest organic performers as sponsored — those have already proven engagement. Weeks 3-4 roll fresh creatives based on week 1-2 data, so we're not running tired assets by the end.\n\nLead forms are 4 fields (down from our usual 7), which Priya flagged will pull in higher intent but we'll need to watch SQL conversion. Targeting locked to VP+ engineering titles at 50-500 HC SaaS companies." },

    { role: 'user', text: "Has Priya reviewed all of it?" },
    { role: 'agent', text: "Fully signed off. She reviewed all 8 post creatives yesterday afternoon, approved the targeting rules, and signed the form copy. Her exact words: \"Green-light this — the targeting is the tightest we've ever shipped.\"\n\nShe's also asked to run a weekly pulse-check instead of waiting for the 4-week wrap, which I'm glad she pushed for." },

    { role: 'user', text: "What are the biggest risks?" },
    { role: 'agent', text: "Creative fatigue if the week 3-4 refresh underperforms — we could land at the bottom of the range (40 MQLs) instead of the top (55).\n\nSecondary risk is lead-form friction. The 4-field form pulls more volume but lower intent than the 7-field form we used to run. If SQL rate on this campaign dips below 15%, we add fields back in week 2." },

    { role: 'user', text: "What does the upside case look like if everything clicks?" },
    { role: 'agent', text: "55 MQLs at the top of the range, SQL conversion at 22%+ because the dev audience has been self-qualifying through our organic content, and CPL lands in the $58-$65 band.\n\nIf we hit that, we double down in month two — I'd propose a $6,400 extension to run two parallel streams, one for VP Engineering and one for Staff+ engineers. But that's a conversation for Q3, not today." },

    { role: 'user', text: "Make sure Wright is iterating on post performance week-over-week." },
    { role: 'agent', text: "Noted. Priya will pair Wright into the weekly pulse-check so he sees the data alongside her. Any creative tweaks get shipped inside 48 hours of the weekly read — no waiting for cycle boundaries." },

    { role: 'user', text: "Alright — launch Thursday. I want a Friday 48-hour wrap in my briefing." },
    {
      role: 'agent',
      text: "Launching Thursday.",
      executionSteps: [
        'Committed $3,200 budget for LinkedIn Developer Series',
        'Scheduled campaign launch for Thursday 9 AM',
        'Locked Friday 48-hour wrap cadence with Priya',
        'Pulled Wright into the weekly pulse-check loop',
      ],
      priyaTask: {
        title: 'LinkedIn Dev Series launch + Friday 48h wrap',
        context: 'Arjun approved the $3,200 launch. Priya delivers a Friday-morning 48-hour wrap (CPL + MQL volume) and runs weekly pulse-checks with Wright.',
        agent: 'marsi',
        dueDate: 'Launch Thursday 9 AM',
      },
      closure: "You'll have the Friday wrap in your morning briefing. If CPL is tracking clean, we plan the Q3 extension. If not, we pause before week 2 spend.",
      ripple: { approveDecision: 'ap2' },
    },

    { role: 'user', text: "Great. Let me know Friday." },
    { role: 'agent', text: "Will do. Talk soon." },
    { role: 'complete-pill' },
  ],

  /* ── PLG Content Series (LIVE, no linked alerts/decisions) ──── */
  mc3: [
    { role: 'user', text: "PLG Content Series — how's it shaping up?" },
    { role: 'agent', text: "It's the strongest content motion we've ever run. $800 of the $1,200 budget spent, and we have three target keywords in the top-10 organic rankings — \"AI orchestration for SMBs,\" \"AI ops workflows,\" and \"multi-agent platforms for startups.\" All three were below page 3 six weeks ago.\n\nBlog traffic is up 14% WoW, organic leads are 18 for the month, and average time on page is 4 minutes 12 seconds — high-intent reading behavior." },

    { role: 'user', text: "Numbers look great. What's your concern?" },
    { role: 'agent', text: "Concentration risk. All our wins are SEO-driven, and SEO is structurally fragile. One Google algorithm update could shift our rankings overnight, and we'd lose 60-70% of the traffic in a week with no ability to defend.\n\nWe've seen this pattern at other SaaS companies — dominant SEO content, great numbers, one algo update and the pipeline shuts off. I don't want to be running blind when that happens." },

    { role: 'user', text: "How exposed are we if rankings drop?" },
    { role: 'agent', text: "Direct impact: ~60% of our organic inbound vanishes. Roughly 11 leads a month, $22K of pipeline contribution.\n\nIndirect impact is worse — sales reps have been quoting our blog content in demo prep, and it's reinforcing our thought leadership positioning. Losing rankings would soften that narrative before we have a replacement motion." },

    { role: 'user', text: "How do we hedge?" },
    { role: 'agent', text: "Three parallel moves:\n\n1. Diversify channels. Add email nurture and LinkedIn syndication so our content reaches audiences without depending on search.\n\n2. Build a crisis-response playbook. If rankings drop, we need a 48-hour pivot plan — which channels to double down on, which content to re-purpose, how to defend traffic.\n\n3. Earn non-SEO backlinks. Guest posts on SaaS founder publications, podcast appearances. Harder to build, harder to lose." },

    { role: 'user', text: "Focus on the crisis playbook — what would Wright need to build it?" },
    { role: 'agent', text: "Six to eight hours of his time. Structure would be: a ranking-drop alert trigger (tied to our SEO tool), a prioritized channel-pivot matrix, pre-approved email and LinkedIn templates for each top-10 keyword, and a weekly drill cadence so the team isn't learning during an actual crisis.\n\nWright has the content sensibilities for it. Priya can own the operational cadence and keep it living." },

    { role: 'user', text: "Do it. Have Wright build the playbook, Priya owns the timeline." },
    {
      role: 'agent',
      text: "On it.",
      executionSteps: [
        'Scoped crisis-response playbook with Wright — 6-8 hrs effort',
        'Priya owning the delivery timeline + weekly drill cadence',
        'Hooked SEO-tool ranking-drop alerts into the playbook trigger',
        'Task routed to Priya — she\'ll keep it living',
      ],
      priyaTask: {
        title: 'SEO crisis-response playbook — Wright authored, Priya owned',
        context: 'Arjun commissioned a ranking-drop crisis playbook. Wright drafts, Priya owns operational cadence and runs quarterly drill simulations.',
        agent: 'marsi',
        dueDate: 'Draft in 2 weeks',
      },
      closure: "I'll send you the draft playbook for review in two weeks. If it feels light, we add depth before making it operational.",
    },

    { role: 'user', text: "And the syndication angle — what's our current read?" },
    { role: 'agent', text: "Briefly explored, not executed. Dora has preliminary data on the top 3 SMB-founder newsletters and 2 LinkedIn creator channels that fit our ICP.\n\nThe play is licensing our best-performing blog content for their audiences — we lose some direct attribution but gain brand reach in high-trust environments. Costs roughly $400/month per channel." },

    { role: 'user', text: "Let's come back to syndication next month." },
    { role: 'agent', text: "Fair. I'll re-surface it with a full proposal in your monthly briefing — channels, costs, expected reach, and attribution model." },

    { role: 'user', text: "Great. Thanks Marsi." },
    { role: 'agent', text: "Will do. Talk soon." },
    { role: 'complete-pill' },
  ],
};

